module.exports = __webpack_public_path__ + "static/media/Vegifyit-Logo-RGB-LR.59df3429.png";